import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Affix, Button, Card } from "antd";
import Header from "components/Common/Header";
import PackingAssignmentForm from "./Form";

const AddOrUpdatePackingAssignment = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  const formRef = useRef(null);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title={isEdit ? "Edit Packing Assignment" : "Add Packing Assignment"}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button
                size="small"
                key={1}
                danger
                onClick={() => navigate("/digitalization/packing/assignment")}
              >
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => formRef.current?.submit()}>
                {isEdit ? "Update Packing Assignment" : "Add Packing Assignment"}
              </Button>,
            ]}
          />
        </Card>
      </Affix>
      <PackingAssignmentForm ref={formRef} />
    </>
  );
};

export default AddOrUpdatePackingAssignment;
